// React Imports
import { useEffect, useRef, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch, useSelector } from "react-redux";
import { checkUsertoken } from "../../../../redux/features/login/login";
import {
  ownerAccountsDetailsById,
  resetOwnerBalance,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  addNewLabelRequest,
  removeNewLabelRequest,
} from "../../../../redux/features/reimbursementRequest/index.js";
import { ReimbursementRequestTxnMultiWaitingApproval } from "../../../../redux/features/reimbursementTransaction";

// Utils Imports
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";

// Component Imports
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import formatAmountTwoDecimals from "../../../../utils/formatAmountTwoDecimals.js";
import Loader from "../../../Loader/Index";
import CommonAssignLabelPopup from "../../../_utils/CommonPopups/CommonAssignLabelPopup";
import CommonBulkEditModel from "../../../_utils/CommonPopups/CommonBulkEditModel";
import CommonRequestDetailsCard from "../../../_utils/CommonRequestDetailsCard";
import CommonToast from "../../../_utils/CommonToast";
import ApprovalTopNavComponent from "../../../_utils/CommonTopNav/ApprovalTopNav";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import ReimbursementRequestDeclinePopup from "../../../_utils/TransactionCommonComponents/CommonDeclinePopups/ReimbursementRequestDeclinePopup";
import CommonAccountModal from "../../../_utils/TransactionCommonComponents/CommonSourceAccount/CommonAccountModal";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount.js";

const ReimbursementRequestTxnMultiApprovalDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const refreshingToastId = useRef(null);
  const activeTransactionIdRef = useRef(null);
  const bulkSelectRef = useRef(false);
  const labelActionDispatchedRef = useRef(false);
  const amountExceedToastShownForRequestId = useRef(new Set());
  const rtgsMinAmountToastShownForRequestId = useRef(new Set());
  const neftMaxAmountToastShownForRequestId = useRef(new Set());

  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isMobileResponsive, setIsMobileResponsive] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const [transactionFilterID, setTransactionFilterID] = useState([]);
  const [deniedId, SetdeniedId] = useState();
  const [showBulkEdit, setShowBulkEdit] = useState(false);

  const [ownerAccountPopup, setOwnerAccountPopup] = useState(false);
  const [activeTransactionId, setActiveTransactionId] = useState(null);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [bulkSelectedAccount, setBulkSelectedAccount] = useState(null);
  const [bulkEditAvailableLabels, setBulkEditAvailableLabels] = useState([]);
  const [bulkEditSelectedLabels, setBulkEditSelectedLabels] = useState([]);
  const [bulkEditLabelPopupOpen, setBulkEditLabelPopupOpen] = useState(false);
  const [bulkEditLabelLoading, setBulkEditLabelLoading] = useState(false);
  const bulkEditInitialLabelsRef = useRef([]);

  const [isLabelPopupOpen, setisLabelPopupOpen] = useState(false);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [txnlabels, settxnLabels] = useState([]);
  const [labelLoading, setLabelLoading] = useState(false);

  // NEW STATES: Localized popup stability mapping
  const [labelPopupAccounts, setLabelPopupAccounts] = useState([]);

  const services = useSelector((state) => state.refreshToken.services);
  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementRequestTxnData"),
    );

    if (storedSelectedApproval) {
      setTransactionFilterData(
        storedSelectedApproval?.selectedSendTransactions,
      );
      setTransactionFilterID(storedSelectedApproval.selectedTransactions);
    } else {
      setTransactionFilterData([]);
      setTransactionFilterID([]);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileResponsive(
        window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
      );
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (createTransactionBankRefreshLoading) {
      toast.dismiss();
      refreshingToastId.current = UniversalRefreshToast();
    } else if (createTransactionBankRefreshData?.status) {
      toast.dismiss(refreshingToastId.current);
      refreshingToastId.current = null;

      CommonToast({
        text: "Balance refreshed successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    } else if (
      createTransactionBankRefreshError &&
      !createTransactionBankRefreshLoading
    ) {
      toast.dismiss(refreshingToastId.current);
      refreshingToastId.current = null;

      CommonToast({
        text: createTransactionBankRefreshError,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }

    if (createTransactionBankRefreshData) {
      let data = transactionFilterData.map((val) => {
        if (
          val.owner_account_id ===
          createTransactionBankRefreshData?.owner_accounts[
            GlobalConfiguration.lengthCheckZero
          ]?.owner_account_id
        ) {
          return {
            ...val,
            owner_account_balance:
              createTransactionBankRefreshData?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance,
            owner_account_balance_last_fetched_at_in_words:
              createTransactionBankRefreshData?.owner_accounts[
                GlobalConfiguration.lengthCheckZero
              ]?.owner_account_balance_last_fetched_at_in_words,
          };
        }
        return val;
      });

      setTransactionFilterData(data);
      const selectedscheduleData = {
        selectedSendTransactions: data,
        selectedTransactions: transactionFilterID,
      };

      sessionStorage.setItem(
        "selectedReimbursementRequestTxnData",
        JSON.stringify(selectedscheduleData),
      );
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    dispatch,
    transactionFilterID,
    transactionFilterData,
  ]);

  let total = transactionFilterData?.reduce((acc, obj) => {
    return acc + parseInt(obj?.requested_amount);
  }, GlobalConfiguration.lengthCheckZero);

  useEffect(() => {
    if (isLabelPopupOpen) {
      const availableLabels = JSON.parse(
        sessionStorage.getItem("AvailableLabelsRequest") || "[]",
      );
      settxnLabels(availableLabels);
    }
  }, [isLabelPopupOpen]);

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids?.[0]?.errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const syncSessionStorageWithData = (updatedData) => {
    const storedData = JSON.parse(
      sessionStorage.getItem("selectedReimbursementRequestTxnData"),
    );
    if (storedData) {
      sessionStorage.setItem(
        "selectedReimbursementRequestTxnData",
        JSON.stringify({
          ...storedData,
          selectedSendTransactions: updatedData,
          selectedTransactions: transactionFilterID,
        }),
      );
    }
  };

  const handleLabelPopupClose = () => {
    setisLabelPopupOpen(false);
    setLabelPopupAccounts([]);
    labelActionDispatchedRef.current = false;
  };

  const handleAssignLabelsProp = async (labelsToAssign, whichToast = "new") => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);

    const res = await dispatch(
      addNewLabelRequest({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (addNewLabelRequest.fulfilled.match(res)) {
      toast.dismiss();

      setLabelPopupAccounts((prev) =>
        prev.map((acc) => ({
          ...acc,
          labels: [...new Set([...(acc.labels || []), ...labelsToAssign])],
        })),
      );

      setTransactionFilterData((prev) => {
        const idsSet = new Set(recordIds.map((id) => String(id)));

        const updated = prev.map((item) =>
          idsSet.has(String(item.request_id))
            ? {
                ...item,
                labels: [
                  ...new Set([...(item.labels || []), ...labelsToAssign]),
                ],
              }
            : item,
        );

        syncSessionStorageWithData(updated);
        return updated;
      });

      labelActionDispatchedRef.current = true;

      CommonToast({
        text:
          whichToast === "new"
            ? "New label assigned successfully."
            : "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }

    if (addNewLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }

    setLabelLoading(false);
    return addNewLabelRequest.fulfilled.match(res);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labeltxnid);
    const res = await dispatch(
      removeNewLabelRequest({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabelRequest.fulfilled.match(res)) {
      toast.dismiss();

      setLabelPopupAccounts((prev) =>
        prev.map((acc) => ({
          ...acc,
          labels: (acc.labels || []).filter(
            (l) => !labelsToUnassign.includes(l),
          ),
        })),
      );

      setTransactionFilterData((prev) => {
        const idsSet = new Set(recordIds.map((id) => String(id)));
        const updated = prev.map((item) =>
          idsSet.has(String(item.request_id))
            ? {
                ...item,
                labels: (item.labels || []).filter(
                  (l) => !labelsToUnassign.includes(l),
                ),
              }
            : item,
        );
        syncSessionStorageWithData(updated);
        return updated;
      });
      labelActionDispatchedRef.current = true;

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }

    if (removeNewLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }

    setLabelLoading(false);
    return removeNewLabelRequest.fulfilled.match(res);
  };

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleTxnApproval = async (id) => {
    if (!allFieldsFilled) {
      setSubmitAttempted(true);
      const hasRtgsMinError = transactionFilterData?.some(
        (t) =>
          t?.payment_method === "RTGS" &&
          Number(t?.approved_amount ?? t?.requested_amount) >
            GlobalConfiguration.lengthCheckZero &&
          Number(t?.approved_amount ?? t?.requested_amount) < RTGS_MIN_AMOUNT,
      );
      const hasNeftMaxError = transactionFilterData?.some(
        (t) =>
          t?.payment_method === "NEFT" &&
          Number(t?.approved_amount ?? t?.requested_amount) > NEFT_MAX_AMOUNT,
      );
      const toastMessage = hasRtgsMinError
        ? "Minimum amount for RTGS should be 2 lakhs."
        : hasNeftMaxError
          ? "Maximum amount for NEFT should be up to 2 lakhs."
          : "The 'Approve and Pay' button is disabled until all required fields are filled.";
      CommonToast({
        text: toastMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      return;
    }

    setLoading(true);

    if (!isMobileResponsive) {
      showLoadingToast("Approving requests and creating transactions");
    }

    if (transactionFilterID.length > GlobalConfiguration.lengthCheckZero) {
      const reimbursement_requests = transactionFilterData.map((val) => ({
        request_id: val?.request_id,
        reimbursement_amount: Number(
          val?.approved_amount ?? val?.requested_amount,
        ),
        owner_account_id: val?.owner_account_id,
        comments: val?.comment ?? "",
        payment_method: val?.payment_method || undefined,
        labels: val?.labels ?? [],
      }));

      let result;
      try {
        result = await dispatch(
          ReimbursementRequestTxnMultiWaitingApproval({
            reimbursement_requests,
          }),
        ).unwrap();
      } catch (err) {
        result = err;
      }

      setTimeout(() => {
        setLoading(false);
        toast.dismiss();
        const payload = result?.payload ?? result;

        const hasError =
          payload?.status === errorcode.errorFailed ||
          payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ];
        if (hasError) {
          if (
            payload?.errors?.user_unauthorized?.[
              GlobalConfiguration.lengthCheckZero
            ]
          ) {
            setTimeout(() => {
              navigate("/feature_not_assigned", {
                state: {
                  unavailableService: "AReimbursementRequest, Admin",
                },
              });
            }, IntervalConfiguration.intervalMedium);
          } else {
            setTimeout(() => {
              CommonToast({
                text: payload?.error || "Approval failed. Please try again.",
                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
                btnProps: {
                  enabledBgColor: "var(--primary-bg)",
                  enabledTextColor: "var(--text-primary)",
                  btnText: "",
                  handleFunction: () => {},
                  icon: "",
                  btnType: "button",
                  isDisabled: false,
                  hoverOption: "white",
                },
              });
            }, IntervalConfiguration.intervalMedium);
          }
          return;
        }
        if (payload?.status === true) {
          const allTransactions = payload?.requests ?? [];
          const selectedscheduleData = {
            selectedSendTransactions: allTransactions,
            selectedTransactions: transactionFilterID,
          };

          sessionStorage.setItem(
            "selectedReimbursementRequestTxnData",
            JSON.stringify(selectedscheduleData),
          );
          navigate(
            "/reimbursement_transaction_dashboard/reimbursement_request_multi_select/reimbursement_request_multi_approval/request_multi_transaction_success",
            { replace: true },
          );
        } else if (
          !payload ||
          payload?.status === false ||
          payload?.response?.data?.status === false
        ) {
          navigate(
            "/reimbursement_transaction_dashboard/reimbursement_request_multi_select/reimbursement_request_multi_approval/request_multi_transaction_error",
            { replace: true },
          );
        }
      }, IntervalConfiguration.intervalExtraLarge);
    }
  };

  const paymentMethods = ["NEFT", "RTGS"];
  const RTGS_MIN_AMOUNT = GlobalConfiguration.rtgs; // 2 lakh
  const NEFT_MAX_AMOUNT = GlobalConfiguration.rtgs; // NEFT max up to 2 lakh

  const accounts =
    createTransactionBankRefreshData?.owner_accounts?.map(
      (acc) => acc.owner_account_bank_acc_no,
    ) || [];

  const handleOnAccountSelection = async (name, accNo, ifsc, id, account) => {
    const raw = account || {};
    const ownerId = raw.id ?? raw.owner_account_id ?? id;
    const ownerData = {
      bank_acc_no: raw.bank_acc_no ?? raw.owner_account_bank_acc_no ?? accNo,
      id: ownerId,
      owner_account_balance:
        raw.owner_account_balance ?? raw.balance ?? undefined,
      ifsc_code: raw.ifsc_code ?? raw.owner_account_ifsc_code ?? ifsc,
    };
    const bankAccNoStr =
      ownerData.bank_acc_no != null ? String(ownerData.bank_acc_no) : "";

    if (bulkSelectRef.current) {
      setBulkSelectedAccount({
        selectedSourceAccount: formatAccountNumber(bankAccNoStr) || "",
        owner_account_id: ownerData.id,
        owner_account_bank_acc_no: ownerData.bank_acc_no,
        owner_account_ifsc_code: ownerData.ifsc_code,
        owner_account_balance: ownerData.owner_account_balance,
      });
      setOwnerAccountPopup(false);
      bulkSelectRef.current = false;
      return;
    }

    const targetRequestId =
      activeTransactionIdRef.current ?? activeTransactionId;

    // Get owner account labels: from list response or fetch detail
    let ownerLabels = Array.isArray(raw.labels) ? raw.labels : [];
    if (ownerLabels.length === GlobalConfiguration.lengthCheckZero && ownerId) {
      try {
        dispatch(checkUsertoken());
        const res = await dispatch(ownerAccountsDetailsById(ownerId));
        if (ownerAccountsDetailsById.fulfilled.match(res)) {
          ownerLabels =
            res?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero]
              ?.labels ?? [];
          if (!Array.isArray(ownerLabels)) ownerLabels = [];
        }
      } catch (_) {
        ownerLabels = [];
      }
    }

    setTransactionFilterData((prevData) => {
      const updated = prevData.map((item) => {
        const isActive = String(item.request_id) === String(targetRequestId);
        if (isActive) {
          const existingLabels = item.labels || [];
          const mergedLabels = [
            ...new Set([...existingLabels, ...(ownerLabels || [])]),
          ];
          return {
            ...item,
            selectedSourceAccount: formatAccountNumber(bankAccNoStr) || "",
            owner_account_bank_acc_no: ownerData.bank_acc_no,
            owner_account_id: ownerData.id,
            owner_account_balance: ownerData.owner_account_balance,
            owner_account_ifsc_code: ownerData.ifsc_code,
            labels: mergedLabels,
          };
        }
        return item;
      });
      const storedData = JSON.parse(
        sessionStorage.getItem("selectedReimbursementRequestTxnData"),
      );
      if (storedData) {
        sessionStorage.setItem(
          "selectedReimbursementRequestTxnData",
          JSON.stringify({
            ...storedData,
            selectedSendTransactions: updated,
            selectedTransactions: transactionFilterID,
          }),
        );
      }
      return updated;
    });
    setOwnerAccountPopup(false);
  };

  const getActiveTransaction = () => {
    return transactionFilterData.find(
      (item) => item.request_id === activeTransactionId,
    );
  };

  const bulkInitialPaymentMethod =
    transactionFilterData?.length > GlobalConfiguration.lengthCheckZero &&
    transactionFilterData.every(
      (t) =>
        (t?.payment_method ?? "") ===
        (transactionFilterData[GlobalConfiguration.lengthCheckZero]
          ?.payment_method ?? ""),
    )
      ? (transactionFilterData[GlobalConfiguration.lengthCheckZero]
          ?.payment_method ?? "")
      : "";
  const bulkInitialComment =
    transactionFilterData?.length > GlobalConfiguration.lengthCheckZero &&
    transactionFilterData.every(
      (t) =>
        (t?.comment ?? "") ===
        (transactionFilterData[GlobalConfiguration.lengthCheckZero]?.comment ??
          ""),
    )
      ? (transactionFilterData[GlobalConfiguration.lengthCheckZero]?.comment ??
        "")
      : "";

  const handleOpenBulkEdit = () => {
    const first = transactionFilterData?.[GlobalConfiguration.lengthCheckZero];
    const labelSets = transactionFilterData.map(
      (transaction) =>
        new Set(Array.isArray(transaction?.labels) ? transaction.labels : []),
    );
    const commonLabels = labelSets.length
      ? [...labelSets[GlobalConfiguration.lengthCheckZero]].filter((label) =>
          labelSets.every((labels) => labels.has(label)),
        )
      : [];

    bulkEditInitialLabelsRef.current = commonLabels;
    setBulkEditSelectedLabels(commonLabels);
    if (
      first &&
      transactionFilterData?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const allSameAccount = transactionFilterData.every(
        (t) =>
          String(t?.owner_account_id ?? "") ===
          String(first?.owner_account_id ?? ""),
      );
      if (
        allSameAccount &&
        (first.owner_account_id ||
          first.selectedSourceAccount ||
          first.owner_account_bank_acc_no)
      ) {
        setBulkSelectedAccount({
          selectedSourceAccount:
            first.selectedSourceAccount ||
            formatAccountNumber(String(first.owner_account_bank_acc_no ?? "")),
          owner_account_id: first.owner_account_id,
          owner_account_bank_acc_no: first.owner_account_bank_acc_no,
          owner_account_ifsc_code: first.owner_account_ifsc_code,
          owner_account_balance: first.owner_account_balance,
        });
      } else {
        setBulkSelectedAccount(null);
      }
    } else {
      setBulkSelectedAccount(null);
    }
    setBulkEditAvailableLabels(
      JSON.parse(sessionStorage.getItem("AvailableLabelsRequest") || "[]"),
    );
    setShowBulkEdit(true);
  };

  const handleBulkConfirm = async (bulkData) => {
    const labelsToAdd = bulkEditSelectedLabels.filter(
      (label) => !bulkEditInitialLabelsRef.current.includes(label),
    );
    const labelsToRemove = bulkEditInitialLabelsRef.current.filter(
      (label) => !bulkEditSelectedLabels.includes(label),
    );
    let labelsAdded = false;
    if (
      labelsToAdd.length > GlobalConfiguration.lengthCheckZero &&
      transactionFilterID?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const res = await dispatch(
        addNewLabelRequest({
          record_ids: transactionFilterID,
          labels: labelsToAdd,
        }),
      );
      if (addNewLabelRequest.fulfilled.match(res)) {
        labelsAdded = true;
      }
      if (addNewLabelRequest.rejected.match(res)) {
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
    }

    let labelsRemoved = false;
    if (
      labelsToRemove.length > GlobalConfiguration.lengthCheckZero &&
      transactionFilterID?.length > GlobalConfiguration.lengthCheckZero
    ) {
      const res = await dispatch(
        removeNewLabelRequest({
          record_ids: transactionFilterID,
          labels: labelsToRemove,
        }),
      );
      if (removeNewLabelRequest.fulfilled.match(res)) {
        labelsRemoved = true;
      }
      if (removeNewLabelRequest.rejected.match(res)) {
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
    }

    setTransactionFilterData((prev) => {
      const updated = prev.map((item) => {
        let labels = item.labels || [];
        if (labelsRemoved) {
          labels = labels.filter((label) => !labelsToRemove.includes(label));
        }
        if (labelsAdded) {
          labels = [...new Set([...labels, ...labelsToAdd])];
        }

        return {
          ...item,
          ...(labelsRemoved || labelsAdded ? { labels } : {}),
          ...(bulkSelectedAccount && {
            selectedSourceAccount: bulkSelectedAccount.selectedSourceAccount,
            owner_account_id: bulkSelectedAccount.owner_account_id,
            owner_account_bank_acc_no:
              bulkSelectedAccount.owner_account_bank_acc_no,
            owner_account_ifsc_code:
              bulkSelectedAccount.owner_account_ifsc_code,
            owner_account_balance: bulkSelectedAccount.owner_account_balance,
          }),
          ...(bulkData.paymentMethod && {
            payment_method: bulkData.paymentMethod,
          }),
          ...(bulkData.comment !== undefined && {
            comment: bulkData.comment,
          }),
        };
      });
      const storedData = JSON.parse(
        sessionStorage.getItem("selectedReimbursementRequestTxnData"),
      );
      if (storedData) {
        sessionStorage.setItem(
          "selectedReimbursementRequestTxnData",
          JSON.stringify({
            ...storedData,
            selectedSendTransactions: updated,
            selectedTransactions: transactionFilterID,
          }),
        );
      }
      return updated;
    });
    setShowBulkEdit(false);
    setBulkSelectedAccount(null);
    setBulkEditSelectedLabels([]);
    toast.dismiss();

    CommonToast({
      text: "Details applied to all the requests.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const updatePaymentMethodForRequest = (requestId, paymentMethod) => {
    const requestIdStr = String(requestId);
    if (paymentMethod !== "RTGS") {
      rtgsMinAmountToastShownForRequestId.current.delete(requestIdStr);
    }
    if (paymentMethod !== "NEFT") {
      neftMaxAmountToastShownForRequestId.current.delete(requestIdStr);
    }
    setTransactionFilterData((prev) => {
      const updated = prev.map((item) =>
        String(item.request_id) === String(requestId)
          ? { ...item, payment_method: paymentMethod }
          : item,
      );
      const storedData = JSON.parse(
        sessionStorage.getItem("selectedReimbursementRequestTxnData"),
      );
      if (storedData) {
        sessionStorage.setItem(
          "selectedReimbursementRequestTxnData",
          JSON.stringify({
            ...storedData,
            selectedSendTransactions: updated,
            selectedTransactions: transactionFilterID,
          }),
        );
      }
      const changedItem = updated.find(
        (i) => String(i.request_id) === String(requestId),
      );
      if (
        paymentMethod === "RTGS" &&
        changedItem &&
        Number(changedItem?.approved_amount ?? changedItem?.requested_amount) >
          GlobalConfiguration.lengthCheckZero &&
        Number(changedItem?.approved_amount ?? changedItem?.requested_amount) <
          RTGS_MIN_AMOUNT
      ) {
        // showRtgsMinAmountToast(requestId);
      }
      if (
        paymentMethod === "NEFT" &&
        changedItem &&
        Number(changedItem?.approved_amount ?? changedItem?.requested_amount) >
          NEFT_MAX_AMOUNT
      ) {
        // showNeftMaxAmountToast(requestId);
      }
      return updated;
    });
  };

  const updateAmountForRequest = (requestId, amount) => {
    const item = transactionFilterData.find(
      (i) => String(i.request_id) === String(requestId),
    );
    const requested = Number(item?.requested_amount);
    const numAmount = Number(amount);
    const exceeds =
      requested != null && !Number.isNaN(requested) && numAmount > requested;
    const requestIdStr = String(requestId);

    const isRtgsBelowMin =
      item?.payment_method === "RTGS" &&
      numAmount > GlobalConfiguration.lengthCheckZero &&
      numAmount < RTGS_MIN_AMOUNT;
    if (!isRtgsBelowMin) {
      rtgsMinAmountToastShownForRequestId.current.delete(requestIdStr);
    }
    const isNeftAboveMax =
      item?.payment_method === "NEFT" && numAmount > NEFT_MAX_AMOUNT;
    if (!isNeftAboveMax) {
      neftMaxAmountToastShownForRequestId.current.delete(requestIdStr);
    }

    if (exceeds) {
      if (!amountExceedToastShownForRequestId.current.has(requestIdStr)) {
        amountExceedToastShownForRequestId.current.add(requestIdStr);
        CommonToast({
          text: "Can not exceed requested amount.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
    } else {
      amountExceedToastShownForRequestId.current.delete(requestIdStr);
    }
    setTransactionFilterData((prev) => {
      const updated = prev.map((item) =>
        String(item.request_id) === String(requestId)
          ? { ...item, approved_amount: amount }
          : item,
      );
      const storedData = JSON.parse(
        sessionStorage.getItem("selectedReimbursementRequestTxnData"),
      );
      if (storedData) {
        sessionStorage.setItem(
          "selectedReimbursementRequestTxnData",
          JSON.stringify({
            ...storedData,
            selectedSendTransactions: updated,
            selectedTransactions: transactionFilterID,
          }),
        );
      }
      const changedItem = updated.find(
        (i) => String(i.request_id) === String(requestId),
      );
      if (
        changedItem?.payment_method === "RTGS" &&
        numAmount > GlobalConfiguration.lengthCheckZero &&
        numAmount < RTGS_MIN_AMOUNT
      ) {
        // showRtgsMinAmountToast(requestId);
      }
      if (
        changedItem?.payment_method === "NEFT" &&
        numAmount > NEFT_MAX_AMOUNT
      ) {
        // showNeftMaxAmountToast(requestId);
      }
      return updated;
    });
  };

  const updateCommentForRequest = (requestId, commentText) => {
    setTransactionFilterData((prev) => {
      const updated = prev.map((item) =>
        String(item.request_id) === String(requestId)
          ? { ...item, comment: commentText }
          : item,
      );
      const storedData = JSON.parse(
        sessionStorage.getItem("selectedReimbursementRequestTxnData"),
      );
      if (storedData) {
        sessionStorage.setItem(
          "selectedReimbursementRequestTxnData",
          JSON.stringify({
            ...storedData,
            selectedSendTransactions: updated,
            selectedTransactions: transactionFilterID,
          }),
        );
      }
      return updated;
    });
  };

  const hasRtgsBelowMin = (t) => {
    const amt = Number(t?.approved_amount ?? t?.requested_amount);
    return (
      t?.payment_method === "RTGS" &&
      amt > GlobalConfiguration.lengthCheckZero &&
      amt < RTGS_MIN_AMOUNT
    );
  };

  const hasNeftAboveMax = (t) => {
    const amt = Number(t?.approved_amount ?? t?.requested_amount);
    return t?.payment_method === "NEFT" && amt > NEFT_MAX_AMOUNT;
  };

  const allFieldsFilled =
    transactionFilterData?.length > GlobalConfiguration.lengthCheckZero &&
    transactionFilterData.every((t) => {
      const amt = Number(t?.approved_amount ?? t?.requested_amount);
      const requested = Number(t?.requested_amount);
      const rtgsValid = t?.payment_method !== "RTGS" || amt >= RTGS_MIN_AMOUNT;
      const neftValid = t?.payment_method !== "NEFT" || amt <= NEFT_MAX_AMOUNT;
      return (
        (t?.selectedSourceAccount || t?.owner_account_id) &&
        t?.payment_method &&
        amt > GlobalConfiguration.lengthCheckZero &&
        amt <= requested &&
        rtgsValid &&
        neftValid
      );
    });

  const getFieldErrors = (t) => {
    const amt = t?.approved_amount ?? t?.requested_amount;
    const requested = Number(t?.requested_amount);
    const amountExceedsRequested =
      requested != null && !Number.isNaN(requested) && Number(amt) > requested;
    const amountInvalidOnSubmit =
      !(Number(amt) > GlobalConfiguration.lengthCheckZero) ||
      (requested != null && Number(amt) > requested);
    const rtgsBelowMin = hasRtgsBelowMin(t);
    const neftAboveMax = hasNeftAboveMax(t);
    return {
      sourceAccount:
        submitAttempted && !(t?.selectedSourceAccount || t?.owner_account_id),
      paymentMethod: submitAttempted && !t?.payment_method,
      amount:
        amountExceedsRequested ||
        rtgsBelowMin ||
        neftAboveMax ||
        (submitAttempted && amountInvalidOnSubmit),
    };
  };

  const handleAssociateCloseModal = () => {
    setOwnerAccountPopup(false);
  };

  return (
    <>
      {showPopup && (
        <ReimbursementRequestDeclinePopup
          handleClose={() => setShowPopup(false)}
          txnId={deniedId}
          selectedRequestData={transactionFilterData}
        />
      )}
      {showBulkEdit && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonBulkEditModel
            isOpen={showBulkEdit}
            onClose={() => {
              setShowBulkEdit(false);
              setBulkSelectedAccount(null);
              setBulkEditSelectedLabels([]);
            }}
            onConfirm={handleBulkConfirm}
            sourceAccountOptions={accounts}
            paymentMethodOptions={paymentMethods}
            onSourceAccountClick={() => {
              bulkSelectRef.current = true;
              setOwnerAccountPopup(true);
            }}
            selectedSourceAccount={
              bulkSelectedAccount?.selectedSourceAccount ?? ""
            }
            initialPaymentMethod={bulkInitialPaymentMethod}
            initialComment={bulkInitialComment}
            onLabelsClick={() => setBulkEditLabelPopupOpen(true)}
            selectedLabelsDisplay={
              bulkEditSelectedLabels?.length
                ? `${bulkEditSelectedLabels.length} selected`
                : "Select labels"
            }
            selectedLabelsCount={
              bulkEditSelectedLabels?.length ??
              GlobalConfiguration.lengthCheckZero
            }
          />
        </div>
      )}
      {bulkEditLabelPopupOpen && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={(selectedLabels) => {
              setBulkEditSelectedLabels(selectedLabels || []);
              setBulkEditLabelPopupOpen(false);
            }}
            closeisDisabled={false}
            labels={bulkEditAvailableLabels}
            setLabels={(updater) => {
              const next =
                typeof updater === "function"
                  ? updater(bulkEditAvailableLabels)
                  : updater;
              setBulkEditAvailableLabels(Array.isArray(next) ? next : []);
              sessionStorage.setItem(
                "AvailableLabelsRequest",
                JSON.stringify(next || []),
              );
            }}
            LabelAccounts={[]}
            isLabelPopupOpen={bulkEditLabelPopupOpen}
            filteredData={[]}
            type="create"
            selectedLabelsCreate={bulkEditSelectedLabels}
            setSelectedLabelsCreate={setBulkEditSelectedLabels}
            loading={bulkEditLabelLoading}
            setLoading={setBulkEditLabelLoading}
          />
        </div>
      )}
      {isLabelPopupOpen && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleLabelPopupClose}
            closeisDisabled={false}
            labels={txnlabels}
            setLabels={settxnLabels}
            LabelAccounts={labeltxnid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={labelPopupAccounts}
            onClose={handleLabelPopupClose}
            loading={labelLoading}
            setLoading={setLabelLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {ownerAccountPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAccountModal
            onAccountSelect={handleOnAccountSelection}
            accountNumber={getActiveTransaction()?.owner_account_bank_acc_no}
            IFSC={getActiveTransaction()?.owner_account_ifsc_code}
            type={"ReibursementRequestMulti"}
            setOpenOwner={setOwnerAccountPopup}
            flow="ReimbursementRequestMultiFlow"
            onClose={handleAssociateCloseModal}
          />
        </div>
      )}

      <div
        className="int-txn-mutli-details-main"
        style={{
          overflow: showPopup ? "hidden" : "",
          height: showPopup ? "var(--full-height)" : "",
        }}
      >
        {loading ? (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <div className="flex justify-center items-center">
              <Loader />
            </div>
          </div>
        ) : null}
        <div className="hidden Qmd:block min-h-[var(--navbar-breadcrumb-height)] h-navbar-breadcrumb-height bg-primary-nav"></div>
        <div className="int-txn-mutli-container">
          <ApprovalTopNavComponent
            handleBack={() =>
              navigate(GlobalConfiguration.lengthCheckNegativeOne)
            }
            topNavCtaBtn1Needed={false}
            topNavHeader={total}
            topNavSubText={"Total amount"}
            topNavCtaBtn1Props={{
              btnText: "Previous",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: () =>
                navigate(GlobalConfiguration.lengthCheckNegativeOne),
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              hoverOption: "white",
            }}
            topNavCtaBtn2Needed={false}
            topNavCtaBtnWithIcon1Props={{
              btnText: "Reject",
              handleFunction: () => handleOpenPopup(transactionFilterID),
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              iconToBeAlign: "right",
              textSemibold: false,
            }}
            topNavCtaBtnWithIcon2Props={{
              btnText: "Approve & pay",
              handleFunction: () => handleTxnApproval(transactionFilterID),
              enabledBgColor: allFieldsFilled
                ? "var(--positive-act)"
                : "var(--text-disabled)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK,
              iconToBeAlign: "right",
              isDisabled: !allFieldsFilled,
              inActiveVariantNeeded: true,
              textSemibold: false,
            }}
            BottomHeader={`Request approval process`}
            BottomSubText={`Select a source account to approve requests. Approved amount can be edited for each request (up to requested amount) and add comments if required..`}
            isToggleNeeded={false}
            isSelectionView={false}
            BottomCtaBtnProps={{
              btnText: "Edit all requests",
              btnType: "button",
              enabledBgColor: "var(--primary-nav-act)",
              handleFunction: handleOpenBulkEdit,
              enabledTextColor: "var(--text-primary)",
              isDisabled: false,
              textSemibold: false,
              hoverOption: "white",
              icon: ICONS?.EDIT_WITH_WHITE_CIRCLE,
            }}
            assignLabelNeeded={false}
            assignTagNeeded={false}
          />
        </div>
        <div className="int-txn-mutli-select-data-card py-padding-md">
          <div className=" flex flex-col gap-gap-md w-full px-padding-md  ">
            {transactionFilterData?.map((v, i) => {
              let val = v;
              if (!v.payment_method) {
                val["payment_method"] =
                  v["requested_amount"] < RTGS_MIN_AMOUNT ? "NEFT" : "RTGS";
              }
              const entries = [
                [
                  {
                    type: "textSubtext",
                    text: val?.beneficiary_account_name,

                    subText: "Account name",
                  },
                  {
                    type: "textSubtext",
                    text: val.created_on
                      ? formatDateViewAll(val.created_on, false, false)
                      : "Not given",
                    subText: "Date",
                  },
                  {
                    type: "textSubtext",
                    text:
                      "INR " + FormatAmount({ price: val?.requested_amount }),
                    subText: "Requested amount",
                    isBold: true,
                  },

                  {
                    type: "cta",
                    text: val?.labels?.length
                      ? val.labels.join(", ")
                      : "Not assigned",
                    subText: "Labels",
                    onClick: (e) => {
                      if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        e.stopPropagation();
                        setLabeltxnid([val?.request_id]);
                        setLabelPopupAccounts(
                          transactionFilterData
                            .filter(
                              (txn) =>
                                String(txn?.request_id) ===
                                String(val?.request_id),
                            )
                            .map((t) => ({ ...t, id: t.request_id })),
                        );
                        setisLabelPopupOpen(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                  },
                ],
              ];
              return (
                <div className="w-full " key={val?.request_id || i}>
                  <CommonRequestDetailsCard
                    categoryId={val?.category_id?.category_id}
                    style
                    entries={entries}
                    paymentMethodOptions={paymentMethods}
                    selectedSourceAccount={val?.selectedSourceAccount || ""}
                    selectedPaymentMethod={val?.payment_method || ""}
                    amount={(() => {
                      const approved = val?.approved_amount;
                      if (approved !== undefined && approved !== null) {
                        String(approved).replace(/,/g, "");
                      }
                      return formatAmountTwoDecimals(val?.requested_amount);
                    })()}
                    comment={val?.comment ?? ""}
                    error={getFieldErrors(val)}
                    onSourceAccountChange={() => {
                      const requestId = val?.request_id;
                      activeTransactionIdRef.current = requestId;
                      setActiveTransactionId(requestId);
                      setOwnerAccountPopup(true);
                    }}
                    onPaymentMethodChange={(method) => {
                      return updatePaymentMethodForRequest(
                        val?.request_id,
                        method,
                      );
                    }}
                    onAmountChange={(amount) => {
                      const r = updateAmountForRequest(val?.request_id, amount);
                      if (amount <= RTGS_MIN_AMOUNT) {
                        updatePaymentMethodForRequest(val?.request_id, "NEFT");
                      } else {
                        updatePaymentMethodForRequest(val?.request_id, "RTGS");
                      }
                      return r;
                    }}
                    onCommentChange={(commentText) =>
                      updateCommentForRequest(val?.request_id, commentText)
                    }
                    onAdornmentClick={(e) => {
                      toast.dismiss();
                      CommonToast({
                        text: "Can not exceed requested amount.",
                        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                        variant: "var(--error)",
                        buttonNeeded: false,
                        btnProps: {
                          enabledBgColor: "var(--primary-bg)",
                          enabledTextColor: "var(--text-primary)",
                          btnText: "",
                          handleFunction: () => {},
                          icon: "",
                          btnType: "button",
                          isDisabled: false,
                          hoverOption: "white",
                        },
                      });
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReimbursementRequestTxnMultiApprovalDetail;
